import React from "react";
import "./ErrorBoundary.css";

/**
 * ErrorBoundary global. Captura errores no manejados de los componentes
 * hijos para evitar que la app entera quede en blanco.
 *
 * Uso:
 *   <ErrorBoundary>
 *     <App />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log para debugging — en producción se podría enviar a un servicio
    // de monitoreo (Sentry, Crashlytics, etc).
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="error-boundary-screen">
        <div className="error-boundary-card">
          <div className="error-boundary-icon">⚠️</div>
          <h1>Algo salió mal</h1>
          <p>
            Ocurrió un error inesperado y no pudimos mostrar esta página.
            Probá refrescar; si el problema persiste, escribinos por email.
          </p>
          {this.state.error?.message && (
            <pre className="error-boundary-detail">
              {String(this.state.error.message).slice(0, 240)}
            </pre>
          )}
          <div className="error-boundary-actions">
            <button className="eb-btn primary" onClick={this.handleReload}>
              Recargar página
            </button>
            <button className="eb-btn" onClick={this.handleHome}>
              Ir al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
